<template>
	<div class="template_box">
		<div class="content_box">
			
			<!-- 有效卡 -->
			<div v-if="cardList && cardList.length  != 0" class="has_data">
				<div class="card_box" v-for="(item, index) in cardList" :key="item.card_id">
					<div class="card_text">
						<div class="top_box">
							<div class="TOZO_img">
								<img src="../../assets/card_list/TOZO.png" alt="">
							</div>
							<div class="card_id">ID：{{ item.card_id }}</div>
						</div>
						
						<div class="bottom_box">
							<div class="card_states">已激活</div>
							<div class="product_name">型号: {{ item.product_name }}</div>
							<div class="expire_date" v-if="item.expire_date">有效期: {{ item.expire_date }}</div>
						</div>
						
					</div>
					<div class="product_img">
						<img :src="item.product_img" alt="">
					</div>
				</div>
				
				<div class="go_expireCardList">
					<span @click="go_expireCardList()">查看失效保修卡</span>
				</div>
			</div>
			<!-- 无卡 -->
			<div v-else class="no_data">
				<div class="no_img">
					<img src="../../assets/card_list/Frame@2x.png" alt="">
				</div>
				<div class="no_text">暂未添加保修卡，快去添加吧</div>
			</div>
			<!-- 添加卡 -->
			<div class="btn_box">
				<el-button type="primary" :loading="isLoading" @click="go_AddCard()">添加</el-button>
			</div>
			
		</div>
	</div>
</template>

<script>
import { inusewarrantycards, getvxuserinfo } from "../../plugins/api.js"

export default {
	name: 'myCardList',
	components: {  },
   data() {
		return {
			vx_open_id:'',
			isLoading: false,
			cardList:[
				// {
				//    card_id: '1232189dhu1dhfhs111s', //卡ID
				//    product_name: 'TOZO Golden X1', //产品型号
				//    product_img: 'https://oss-gzh.tozo.com.cn/upload/202308231022171717_1692757337be0PhfykuQaZWnky.jpg', //产品图片                
				// }, 
				// {
				//    card_id: '1232189dhudhfhs111s', //卡ID
				//    product_name: 'TOZO Golden X1', //产品型号
				//    product_img: 'https://oss-gzh.tozo.com.cn/upload/202308231022171717_1692757337be0PhfykuQaZWnky.jpg', //产品图片                
				// }, 
			]
		}
   },
	
   mounted(){
		let StorageOpenid = localStorage.getItem("vx_open_id") ? localStorage.getItem("vx_open_id") : ''
		this.vx_open_id = this.$route.query.vx_open_id ? this.$route.query.vx_open_id : StorageOpenid
		if(this.vx_open_id){
			this.get_inusewarrantycards()
		}else{
			// 获取URL中的code参数
			const code = new URLSearchParams(window.location.search).get('code');
			this.code = code
			if (code) {
			  // 获取到code，调用接口获取vx_open_id
			  this.get_vxuserinfo(code);
			}else{
				this.$root.$emit('authorize', { url: 'myCardList' }); // 获取授权信息
			}
		}
   },
	
	methods: {
		//从后端获取vx_open_id
		async get_vxuserinfo(code){
			const fd = new window.FormData()
			fd.append("code", code)//微信用户vx_open_id
			await getvxuserinfo( fd ).then((res) => {
				console.log(res)
				if(res.code == 0){
					this.vx_open_id = res.data.vx_open_id;
					localStorage.setItem('vx_open_id', this.vx_open_id)
					this.get_inusewarrantycards()
				}
			}, (err) => {
			  console.log(err)
			})
		},
		
		//获取在用保修卡
		get_inusewarrantycards() {
			const fd = new window.FormData()
			fd.append("vx_open_id", this.vx_open_id)//微信用户vx_open_id
			inusewarrantycards( fd ).then((res) => {
				console.log(res)
				if(res.code == 0){
					this.cardList = res.data.list
				}else{
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: res.message });
				}
			}, (err) => {
				this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: err.message });
				console.log(err)
			})
		},
		
		//查看失效保修卡
		go_expireCardList(){
			this.$router.push({
			  path: "/expireCardList"
			})
		},
		
		//添加保修卡
		go_AddCard(){
			this.isLoading = true
			setTimeout(()=>{
				this.isLoading = false
			},1000)
			this.$router.push({
			  path: "/addCard"
			})
		},
   }
}
</script>

<style lang='less' scoped>
	
@import url("css/cardList.css");
.bottom_box>.card_states{
	color: #2094FA;
}
.card_box{
	background: linear-gradient(136deg, #1D1D24 0%, #414149 52%, #5F5F65 100%);
}
.go_expireCardList{
	margin-top: 24px;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #2094FA;
	line-height: 16px;
	width: 100%;
	text-align: center;
	span{
		cursor: pointer;
		border-bottom: 1px #2094FA solid;
	}
}
.content_box{
	padding-bottom: 100px;
	box-sizing: border-box;
	position: relative;
}
.btn_box{
	position: absolute;
	bottom: 0;
	left: 0;
	padding: 30px 12px 30px 12px;
	box-sizing: border-box;
	width: 100%;
	text-align: center;
	::v-deep .el-button--primary {
	   width: 100%;
		max-width: 200px;
		height: 40px;
		background: #000000;
		border-radius: 6px 6px 6px 6px;
		opacity: 1;
		font-size: 16px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #ffffff;
		border: #000000;
	}
}

</style>
